import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {NgClass, NgIf} from '@angular/common';
import {RouterLink} from '@angular/router';
import {UiIconComponent} from '../ui-icon/ui-icon.component';

@Component({
  selector: 'app-ui-icon-button',
  templateUrl: './ui-icon-button.component.html',
  styleUrls: ['./ui-icon-button.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, NgClass, RouterLink, UiIconComponent],
})
export class UiIconButtonComponent {
  @Input() iconColor = '--grey-3';

  @Input()
  color: 'primary' | 'transparent' = 'transparent';

  @Input()
  size: 'md' | 'lg' = 'md';

  @Input()
  disabled = false;

  @Input()
  classes = '';

  @Input()
  icon = '';

  @Input()
  href = '';

  @Input()
  ariaLabel = '';

  @Output()
  onClick: EventEmitter<Event> = new EventEmitter<Event>();
}
